import React, { useEffect, useState } from 'react'
import "./style.scss"
import { useTranslation } from 'react-i18next'
import { CForm } from '@coreui/react'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { changeLanguage, cleanStorage, setLoginLocalStorageFromLoginAsProps, setLoginLocalStorageProps } from '../../../../components/helper'
import { Link, useNavigate } from 'react-router-dom'
import { useMutation } from 'react-query'
import authService from '../../../../service/reactQueryServices/services/authService'
import { loginType } from '../../../../service/types/authTypes/loginTypes'
import ImageContainer from '../components/imageContainer'
import TopContext from '../components/topContext'
import { useDispatch } from 'react-redux'
import { setUserInfo } from '../../../../service/actions/userActions'
import { initialAxiosInstance } from '../../../../service/apiCall'
import CustomValuesHook from '../../../../Hooks/customValuesHook'
import ToastMessage from '../../../../components/ToastMessage';
import { useSearchParams } from "react-router-dom";
import jwtDecode from "jwt-decode";

const Login = () => {
    const [widthScreen, setWidthScreen] = useState(window.innerWidth)
    const [state, setState] = CustomValuesHook({ displayView: false })
    const navigate = useNavigate();
    const { mutateAsync: login, isLoading } = useMutation("login", authService.postLogin);
    const { mutateAsync: loginTenant, isLoading: loginTenantLoading } = useMutation("postLoginTenant", authService.postLoginTenant);
    const { t, i18n } = useTranslation()
    const dispatch = useDispatch()
    const validation = Yup.object({
        emailorPhoneNumber: Yup.string().email(t("ERRORS.EMILE_INVALID") || "").required(t("ERRORS.EMILE_REQ") || ""),
        password: Yup.string().required(t("ERRORS.PASSWORD_REQ") || ""),

    })

    const [searchParams] = useSearchParams();

    const handleSubmit = async (values: loginType) => {

        try {
            const loginResponse = await login(values)

            if (loginResponse.token) {

                setLoginLocalStorageProps(loginResponse).then(async (state) => {

                    if (loginResponse.tenants.length > 1) {
                        navigate("/loginInstances", { state: { ...state } })
                        localStorage.setItem("multiTenants", JSON.stringify(loginResponse.tenants))
                    } else {
                        const loginTenantResponse = await loginTenant(loginResponse.tenants[0].tenantId)
                        ToastMessage.success(t("TOAST.LOGIN_SUCCESS"))
                        setLoginLocalStorageProps(loginTenantResponse).then((result) => {
                            dispatch(setUserInfo({
                                sipOnlineUser: result,
                                userMenu: loginTenantResponse.jsonMenu,
                                accessToken: loginTenantResponse.token,
                                multiTenants: loginResponse.tenants.length > 1 ? loginResponse.tenants : null
                            }))
                            // window.location.href = "/#/dashboard"
                            initialAxiosInstance(loginTenantResponse.token, i18n.language, loginTenantResponse.tenants[0].tenantId)
                            navigate("/dashboard")
                        })

                    }
                })

            }

        } catch (error: any) {
            console.log(error)
            const errorMessage = error?.response?.data?.title ? error?.response?.data?.title : t("TOAST.GENERAL_ERROR")
            ToastMessage.error(errorMessage)


        }
    }
    const formik = useFormik({
        validationSchema: validation,
        initialValues: { emailorPhoneNumber: '', password: '' },
        onSubmit: handleSubmit,
    })

    useEffect(() => {
        document.title = t("TITLES.LOGIN_PAGE")

        cleanStorage(dispatch).then(() => {
            setState({ displayView: true })
        })

        if (searchParams) {
            try {
                const token = searchParams.get('token');
                let userData: any = null;
                
                if (token) {
                    userData = jwtDecode(token);                    
                    setLoginLocalStorageFromLoginAsProps(userData, token).then(async (state) => {
                        let tenants = JSON.parse(userData?.tenants);
                        if (tenants.length > 1) {
                            navigate("/loginInstances", { state: { ...state } })
                            localStorage.setItem("multiTenants", JSON.stringify(tenants))
                        } else {
                            const loginTenantResponse = await loginTenant(tenants[0].tenantId)
                            ToastMessage.success(t("TOAST.LOGIN_SUCCESS"))
                            setLoginLocalStorageProps(loginTenantResponse).then((result) => {
                                dispatch(setUserInfo({
                                    sipOnlineUser: result,
                                    userMenu: loginTenantResponse.jsonMenu,
                                    accessToken: loginTenantResponse.token,
                                    multiTenants: tenants.length > 1 ? tenants : null
                                }))
                                // window.location.href = "/#/dashboard"
                                initialAxiosInstance(loginTenantResponse.token, i18n.language, loginTenantResponse.tenants[0].tenantId)
                                navigate("/dashboard")
                            })

                        }
                    })
                }

            } catch (error) {

            }
        }


    }, [])
    if (state.displayView) {

        return (
            <div className={`d-flex flex-row justify-content-between auth-form `}>
                <div className='section-right' >
                    <TopContext />
                    <div className='d-flex flex-row justify-content-center' >
                        <div className='login-section login-form'>
                            <h4 className='icon-title d-flex flex-row justify-content-cener'><b>{t('ENTER')}</b></h4>
                            <CForm onSubmit={formik.handleSubmit} >

                                <div className="form-group">
                                    <label htmlFor="inputEmail1" className='d-flex flex-row justify-content-start lbl-frm' >{t('COLUMNS.EMAIL')}</label>

                                    <input type='email' name="emailorPhoneNumber" id="inputEmail1"
                                        value={formik.values.emailorPhoneNumber}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        className='form-control' placeholder={t('COLUMNS.EMAIL') || ""} />
                                    {formik.errors.emailorPhoneNumber && formik.touched.emailorPhoneNumber && <label className='label-danger '>{formik.errors.emailorPhoneNumber}</label>}
                                </div>

                                <div className="form-group">
                                    <label htmlFor="exampleInputPassword1" className='d-flex flex-row justify-content-start lbl-frm' >{t('LABEL.GET_PASSWORD')}</label>
                                    <input type='password' name="password" id="exampleInputPassword1"
                                        value={formik.values.password}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        className='form-control password-input' placeholder={t('PASSWORD') || ""} />
                                    {formik.errors.password && formik.touched.password && <label className='label-danger '>{formik.errors.password}</label>}
                                    <div className='d-flex justify-content-end' > <Link to={"/recoveryPassword"} className='reset-pass-spn'>{t("ACTIONS.RESET_PASSWORD")}</Link> </div>
                                </div>

                                <div className='d-flex flex-row justify-content-center'>
                                    <button className="btn btn-primary auth-form-btn w-100"
                                        disabled={!formik.isValid || !formik.dirty}
                                        type="submit" >  {(loginTenantLoading || isLoading) ?
                                            <div className="spinner-border" role="status" aria-hidden="true"></div> : t('LOGIN')}</button>

                                </div>

                                <div className='login-footer d-flex flex-row justify-content-center form-group'>
                                    <p>
                                        {t("DESCRIPTIONS.IF_DO_NOT_REGISTER")} <Link className='reset-pass-spn' to="/signup/userInfo" >{t("ACTIONS.START_REGISTER")}</Link>
                                    </p>
                                </div>

                            </CForm>
                            <div className='Copywriter d-flex flex-row justify-content-center' style={{ direction: 'ltr' }}>
                                <p>{t('COPY_WRITE')}</p>
                            </div>
                        </div>


                    </div>


                </div>
                <ImageContainer />
            </div>
        )
    }
}

export default Login

